import { joinRange } from './cvDates';
import type { GeneratedCv } from '../types';

// Rend un CV généré en texte lisible — pour préremplir « Note mon CV » et comme payload des
// recommandations d'offre. On omet ats_score/advice (non pertinents pour un CV à noter).
export function cvToPlainText(cv: GeneratedCv): string {
  const lines: string[] = [];
  if (cv.headline.trim()) lines.push(cv.headline.trim());

  if (cv.experiences.length > 0) {
    lines.push('', 'EXPÉRIENCES');
    for (const e of cv.experiences) {
      const range = joinRange(e.start_date, e.end_date);
      lines.push([e.role, e.company].filter(Boolean).join(' - ') + (range ? ` (${range})` : ''));
      e.bullets.forEach((b) => lines.push(`- ${b}`));
    }
  }

  if (cv.projects.length > 0) {
    lines.push('', 'PROJETS');
    for (const p of cv.projects) {
      lines.push(p.date ? `${p.name} (${p.date})` : p.name);
      p.bullets.forEach((b) => lines.push(`- ${b}`));
    }
  }

  if (cv.education.length > 0) {
    lines.push('', 'FORMATION');
    for (const ed of cv.education) {
      lines.push([ed.degree, ed.school].filter(Boolean).join(' - ') + (ed.date ? ` (${ed.date})` : ''));
    }
  }

  if (cv.skills.length > 0) lines.push('', `COMPÉTENCES : ${cv.skills.join(', ')}`);
  if (cv.languages.length > 0) lines.push('', `LANGUES : ${cv.languages.join(', ')}`);
  if (cv.interests.length > 0) lines.push('', `CENTRES D’INTÉRÊT : ${cv.interests.join(', ')}`);

  return lines.join('\n');
}
